// extracted by mini-css-extract-plugin
export default {"topDisclaimerBackground":"TopDisclaimer_topDisclaimerBackground__BRL8a","topDisclaimerText":"TopDisclaimer_topDisclaimerText__J22rv"};